var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.isSubmitted},on:{"click":function($event){return _vm.remove()}}},[(_vm.isSubmitted)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_c('i',{staticClass:"fa fa-times text-danger"})])
}
var staticRenderFns = []

export { render, staticRenderFns }